import { createSlice } from "@reduxjs/toolkit";

const formsSlice = createSlice({
    name: "forms",
    initialState: {
        loginVisible: false,
        signupVisible: false,
        contactVisible: false,
        googlemeetVisible: false,
        dimmed: false
    },
    reducers: {
        updateLoginVisible: (state, action) => {
            state.loginVisible = action.payload
        },
        updateSignupVisible: (state, action) => {
            state.signupVisible = action.payload
        },
        updateContactVisible: (state, action) => {
            state.contactVisible = action.payload
        },
        updateGooglemeetVisible: (state, action) => {
            state.googlemeetVisible = action.payload
        },
        updateDimmed: (state, action) => {
            state.dimmed = action.payload
        }
    }
})

export const { updateLoginVisible, updateSignupVisible, updateContactVisible, updateGooglemeetVisible, updateDimmed } = formsSlice.actions

export default formsSlice.reducer